export default function TechnicalAndSocial() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Technical Precision Section */}
        <div className="mb-20">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 relative">
            {/* Left Image */}
            <div className="relative h-[600px] w-full overflow-hidden rounded-lg">
              <img
                src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/53e5300bf424bc8829ec6ed289517b1c.jpeg"
                alt="Cirurgião concentrado durante procedimento"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Right Image */}
            <div className="relative h-[600px] w-full overflow-hidden rounded-lg">
              <img
                src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/d81dd7cc2315354b379b25ac8b19f8dd.jpeg"
                alt="Procedimento cirúrgico em andamento"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Overlay Text Box */}
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white/95 backdrop-blur-sm p-8 md:p-12 rounded-lg shadow-2xl max-w-md text-center">
              <h3 className="text-3xl md:text-4xl font-bold text-[#6B2432] mb-4">
                Precisão Cirúrgica
              </h3>
              <p className="text-lg text-[#5A5A5A] leading-relaxed">
                Tecnologia de ponta e segurança absoluta
              </p>
              <div className="mt-6 flex justify-center gap-4">
                <div className="flex items-center gap-2">
                  <i className="ri-shield-check-line text-2xl text-[#6B2432]"></i>
                  <span className="text-sm text-[#5A5A5A] font-medium">Segurança</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-microscope-line text-2xl text-[#6B2432]"></i>
                  <span className="text-sm text-[#5A5A5A] font-medium">Precisão</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Social Proof Section */}
        <div>
          {/* Section Header */}
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#5A5A5A] mb-4">
              Sorrisos Reais, Vidas Transformadas
            </h2>
            <p className="text-lg text-[#5A5A5A] max-w-3xl mx-auto">
              Veja os resultados que mudaram a vida de nossos pacientes
            </p>
          </div>

          {/* 6-Column Masonry Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {/* Image 1 */}
            <div className="relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer">
              <div className="w-full h-[400px]">
                <img
                  src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/c457dbc8a23358404e47c62a02a8d2db.jpeg"
                  alt="Paciente sorrindo após tratamento"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Image 2 */}
            <div className="relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer">
              <div className="w-full h-[400px]">
                <img
                  src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/81a6d1b6d11c1110e94722ad47a359f9.jpeg"
                  alt="Resultado de implante dentário"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Image 3 */}
            <div className="relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer">
              <div className="w-full h-[400px]">
                <img
                  src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/daa939599302a29f696ef63d1dd7b80d.jpeg"
                  alt="Harmonização facial resultado"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Image 4 */}
            <div className="relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer">
              <div className="w-full h-[400px]">
                <img
                  src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/a54c721416b7790db9bd5561a90a8a17.jpeg"
                  alt="Reabilitação oral completa"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Image 5 */}
            <div className="relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer">
              <div className="w-full h-[400px]">
                <img
                  src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/b3ad23ff7a4afc436c1c2ab8e9e177ad.jpeg"
                  alt="Cirurgia ortognática resultado"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Image 6 */}
            <div className="relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer">
              <div className="w-full h-[400px]">
                <img
                  src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/39dab2abdce0c7d988ac313804a8724c.jpeg"
                  alt="Estética dental resultado"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
